var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.5V6.6c0-.5.6-.8 1-.5l7.5 6.3c.9.7 2.2.7 3.1 0L19 6.2c.4-.3 1 0 1 .5v7.9c0 1.4-1.1 2.5-2.5 2.5h-15C1.1 17 0 15.9 0 14.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.3 9.7-8-6.6C.8 2.8 1 2 1.6 2h16.8c.6 0 .8.8.4 1.2l-8 6.6c-.5.3-1.1.3-1.5-.1z"
  })));
};
export default SvgMail;